const isIE = () => {
    if (
        navigator.userAgent.indexOf('MSIE') !== -1 ||
    navigator.appVersion.indexOf('Trident/') > -1
    ) {
        return true;
    }
    return false;
};

const isEdge = () => window.navigator.userAgent.indexOf('Edge') > -1;

module.exports = {
    isIE,
    isEdge,
};
